import { forwardRef, IconButton, IconButtonProps } from '@cardboard-ui/react';
import React from 'react';

export const UserInfoActionButton = forwardRef<IconButtonProps, 'button'>(
  (props, ref) => (
    <IconButton
      ref={ref}
      size="sm"
      variant="solid"
      w={8}
      h={8}
      bg="gray.50"
      _dark={{ bg: 'gray.600' }}
      borderRadius="100%"
      {...props}
    />
  ),
);
